<template>
  <article
    class="list bg-base-100 rounded-box border-base-200 border shadow-sm"
  >
    <div class="list-row items-center gap-4 p-4">
      <div
        class="bg-primary/10 text-primary rounded-box flex size-12 shrink-0 items-center justify-center text-xl font-bold"
      >
        {{ campaign.name.charAt(0).toUpperCase() }}
      </div>

      <div class="list-col-grow min-w-0">
        <div class="flex flex-wrap items-center gap-2">
          <RouterLink
            :to="{
              name: 'CampaignClients',
              params: { campaign_id: campaign.id },
            }"
            class="text-base-content truncate font-semibold hover:underline"
          >
            {{ campaign.name }}
          </RouterLink>
          <span class="badge badge-info badge-soft badge-sm">
            {{ campaign.agentCount ?? 0 }} máy trạm
          </span>
        </div>
        <p
          :class="{
            'text-base-content/60 truncate text-sm': campaign.description,
            'text-base-content/20 text-sm italic': !campaign.description,
          }"
        >
          {{ campaign.description || "Chưa có mô tả." }}
        </p>
        <time
          class="text-base-content/50 text-xs"
          :datetime="campaign.createdAt"
        >
          Đã tạo
          {{
            Intl.DateTimeFormat("vi-VN", {
              dateStyle: "full",
              timeStyle: "medium",
            }).format(new Date(campaign.createdAt))
          }}
        </time>
      </div>

      <div class="flex flex-wrap justify-end gap-2">
        <RouterLink
          :to="{
            name: 'CampaignClients',
            params: { campaign_id: campaign.id },
          }"
          class="btn"
        >
          <i class="fa-solid fa-circle-info text-base-content/90"></i>
          Chi tiết
        </RouterLink>
        <CampaignUpdateModal
          :campaign="campaign"
          @update="$emit('update', campaign)"
        />
        <CampaignDeleteModal
          :campaign="campaign"
          @delete="$emit('delete', campaign)"
        />
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import CampaignDeleteModal from "./CampaignDeleteModal.vue";
import CampaignUpdateModal from "./CampaignUpdateModal.vue";

const props = defineProps<{
  campaign: {
    id: string;
    name: string;
    description: string;
    createdAt: string;
    agentCount?: number;
  };
}>();

console.log("CampaignCard props:", JSON.stringify(props.campaign));

defineEmits<{
  view: [campaign: { id: string }];
  update: [campaign: { id: string }];
  delete: [campaign: { id: string }];
}>();
</script>
